import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        Deatlov Projects
      </header>
    </div>
  );
}

export default App;
